import { createFileRoute } from '@tanstack/react-router';

import { userListQueryOptions, UsersPage } from '@/features/users';

/** Any platform role may read the list; the page hides what the role cannot do. */
export const Route = createFileRoute('/_authed/users')({
  staticData: { crumbKey: 'nav.platformUsers', tours: ['platform.users'] },
  loader: ({ context }) =>
    context.queryClient.query({ ...userListQueryOptions(), staleTime: 'static' }),
  component: UsersPage,
});
